<template>
  <div class="h-auto w-full mr-3 min-h-screen">
    <div class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold">SMS Gateways</p>
        <button @click="showEditGateway = true" class="bg-primary text-white  px-3 text-sm py-1  rounded-md my-1">
          Edit SMS Gateway
        </button>
      </div>
      <div class="p-2 relative">
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
            <loader class="center-h-v" />
          </div>
        </transition>
        <transition name="fade">
          <div v-if="showSMSEditSuccess" class="p-1 text-center text-sm w-full bg-green-200">
            {{ edit_success }}
          </div>
        </transition>
        <ve-table :columns="columns" :table-data="tableData" />
        <transition name="fade">
          <div v-if="get_error" class="p-1 text-center text-sm w-full bg-yellow-200">
            {{ get_error }}
          </div>
        </transition>
      </div>
    </div>

    <!-- Edit -->
    <EditGateway @close="handleClose" :showEditGateway="showEditGateway" @closeOnSuccess="handleCloseOnSuccess"
      :data="tableData[0] || tableData"></EditGateway>

    <SmsTemplates :smsTemplatesList="smsTemplatesList" :smsVariables="smsVariables" :loading="loading"
      :loadingTemplates="loadingTemplates" @updateSmsTemplatesList="updateSmsTemplatesList"></SmsTemplates>
  </div>
</template>

<script>
import axios from "axios";
import EditGateway from "@/components/AdminSetups/sms/editGateway.vue";
import SmsTemplates from "@/components/AdminSetups/sms/smsTemplate.vue";
import Loader from "@/components/loader/loader.vue";
import { mapGetters } from "vuex";
export default {
  name: "SMSs",
  components: { Loader, EditGateway, SmsTemplates },
  data() {
    return {
      get_error: null,
      showEditGateway: false,
      showSMSEditSuccess: false,
      loadingTemplates: false,
      edit_success: null,
      smsTemplatesList: null,
      smsVariables: null,
      loading: false,
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "APIKey",
          key: "a",
          title: "API Key", headerAlign: 'left',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return (
              <p
                on-click={() => (this.showEditGateway = true)}
                class="text-blue-500 cursor-pointer"
              >
                {row.APIKey}
              </p>
            );
          },
        },
        {
          field: "PartnerId", key: "b", title: "Partner Id", headerAlign: 'left',
          align: 'left',
        },
        {
          field: "RequestURI", key: "c", title: "Request URI", headerAlign: 'left',
          align: 'left',
        },
        {
          field: "Shortcode",
          key: "x",
          title: "Shortcode",
        },
      ],

      tableData: [],
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  created() {
    this.getSMSGateways();
  },
  methods: {
    handleClose() {
      this.showEditGateway = false;
    },
    handleCloseOnSuccess(message) {
      this.edit_success = message;
      this.showEditGateway = false;
      this.showSMSEditSuccess = true;
      setTimeout(() => {
        this.showSMSEditSuccess = false;
      }, 3000);
      this.getEmailGateways();
    },
    getSMSGateways() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(`setup/v1/request`, options).then(
        (response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            this.tableData.push(response.data.Setups.smsSetup);
            this.smsTemplatesList = response.data.Setups.smsTemplates;
            this.smsVariables = response.data.Setups.smsVariables;
          } else {
            this.get_error = response.data.StatusMessage;
          }
        },
        (error) => {
          this.loading = false;
          this.get_error = error.message;
        }
      );
    },
    updateSmsTemplatesList() {
      this.loadingTemplates = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(`setup/v1/request`, options).then(
        (response) => {
          this.loadingTemplates = false;
          if (response.data.StatusCode == 200) {
            this.smsTemplatesList = response.data.Setups.smsTemplates;
          } else {
            this.get_error = response.data.StatusMessage;
          }
        },
        (error) => {
          this.loadingTemplates = false;
          this.get_error = error.message;
        }
      );
    },
  },
};
</script>
